// Best-effort mirror of Shopify customer metafields onto Klaviyo profile properties.
// Values are read server-side from Shopify Admin; callers only name which keys to sync.
async function syncKlaviyoProfileProperties(keys) {
  const url = KROWN?.settings?.api_urls?.klaviyo_notifications_url;
  if (!url || !Array.isArray(keys) || keys.length === 0) return;

  const response = await fetch(url + '/sync-profile-properties', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ keys }),
  });

  if (!response.ok) {
    console.warn('Klaviyo profile property sync failed:', response.status, await response.text());
  }
}

window.syncKlaviyoProfileProperties = syncKlaviyoProfileProperties;
